import React from 'react';
import logo from './auxmod_logo.svg';
import display_1 from './display_1.svg';
import display_2 from './display_2.svg';

const LandingPageMobile = () => {
  return (
    <div className="container-fluid vh-100 d-flex flex-column p-3 position-relative">
      {/* Logo */}
      <div className="d-flex flex-column align-items-left mt-2 mb-3">
        <img src={logo} alt="auXmod logo" style={{ width: '80px' }} />
        <h5 className="text-dark mt-2 mb-0">auXmod</h5>
      </div>

      {/* Main Content */}
      <div className="text-center px-2 mt-4">
        <h2 style={{ fontSize: '2rem' }}>Cleanify is now auXmod!</h2>
        <p className="mt-3" style={{ fontSize: '1rem' }}>
          Loved Cleanify? You'll love auXmod even more. Automatically replace songs with clean versions, plus theme-based moderation to ensure playlists are perfect for any space.
        </p>

        {/* Features */}
        <div className="mt-4">
          <div className="mb-3">
            <h6 className="font-weight-bold">What hasn't changed:</h6>
            <p>
              auXmod still automatically replaces explicit songs with their clean versions when you select the Profanity filter—just like Cleanify always did.
            </p>
          </div>
          <div>
            <h6 className="font-weight-bold">What's new:</h6>
            <p>
              Filter based on themes like violence & sexual content and whitelist words, giving you more control over what's appropriate for your space.
            </p>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="d-flex flex-row align-items-center mt-4">
          <a
            href="https://auxmod.netlify.app/app"
            className="btn btn-warning rounded-pill"
            style={{ backgroundColor: '#FFD8A8', fontSize: '1rem' }}
          >
            Try now!
          </a>
          <a
            href="https://auxmod.netlify.app/"
            className="btn btn-warning rounded-pill "
            style={{ backgroundColor: '#FFD8A8', fontSize: '1rem' }}
          >
            Learn More
          </a>
        </div>
      </div>

      {/* Footer */}
      <div className="text-center mt-auto mb-2">
        {/* <small className="text-muted">© 2025 Cleanify. Created by Briana King.</small> */}
      </div>
    </div>
  );
};

export default LandingPageMobile;
